// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { twoSquaresInBrackets } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-two-squares-in-brackets': IconTwoSquaresInBrackets;
    }
}

/**
 * The icon component for the 'twoSquaresInBrackets' icon
 */
export class IconTwoSquaresInBrackets extends IconSvg {
    public constructor() {
        super(twoSquaresInBrackets);
    }
}

registerIconSvg('icon-two-squares-in-brackets', IconTwoSquaresInBrackets);
export const iconTwoSquaresInBracketsTag = 'nimble-icon-two-squares-in-brackets';
